import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Typography, Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined'
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined'

import {
  NOTI_PRIORITY_LOW,
  NOTI_PRIORITY_HIGH,
  NOTI_PRIORITY_URGENT,
  NOTI_PRIORITY_EMERGENCY,
} from 'app/constants/priority'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'

import UrgentIcon from 'app/components/icons/UrgentIcon'
import EmergencyIcon from 'app/components/icons/EmergencyIcon'

const useStyles = makeStyles({
  tooltip: {
    fontWeight: 400,
    fontSize: '12px',
  },
})

const MessagePriority = (props) => {
  const { level = 1 } = props

  const classes = useStyles()

  const renderLevelIcon = (level) => {
    switch (level) {
      case NOTI_PRIORITY_LOW.id:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.priority.informational"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            <NotificationsNoneOutlinedIcon
              style={{ color: '#183560' }}
              fontSize="small"
            />
          </PrimaryTooltip>
        )
      case NOTI_PRIORITY_HIGH.id:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.priority.important"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            <NotificationsActiveOutlinedIcon
              style={{ color: '#183560' }}
              fontSize="small"
            />
          </PrimaryTooltip>
        )
      case NOTI_PRIORITY_URGENT.id:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.priority.urgent"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            <Icon>
              <UrgentIcon />
            </Icon>
          </PrimaryTooltip>
        )
      case NOTI_PRIORITY_EMERGENCY.id:
        return (
          <PrimaryTooltip
            title={
              <Typography className={classes.tooltip}>
                <FormattedMessage
                  id="timeline.detail.message.priority.emergency"
                  values={{
                    b: (text) => <b>{text}</b>,
                  }}
                />
              </Typography>
            }
          >
            <Icon>
              <EmergencyIcon />
            </Icon>
          </PrimaryTooltip>
        )
      default:
        return
    }
  }

  return <>{renderLevelIcon(level)}</>
}

MessagePriority.propTypes = {
  level: PropTypes.number,
}

export default MessagePriority
